import React from 'react';


export default function NoSolutionsSelected() {
    return <div className="emptyContent"><p className="emptyContent__text">Let's find your best solution</p></div>;
}